import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestOvertime } from "../../entity/EntityRequestOvertime";

export class DtoRequestOvertimesGetRes extends EntityRequestOvertime {
  public items: EntityRequestOvertime[]  = [];
}
